<template>
<!--    <el-button class="top-search-btn">-->
<!--        <el-icon>-->
<!--            <Search />-->
<!--        </el-icon>-->
<!--        &nbsp;&nbsp;<span tkey="搜索">{{i18n.tkey("lang_search_text")}}</span>...-->
<!--    </el-button>-->
    <img :src="`${publicPath}static/images/search.png`" style="width: 60px; height: 60px" alt="icon">
</template>

<script setup>

import {Search} from "@element-plus/icons-vue";
import {inject} from "vue";

const i18n = inject("i18n")

const publicPath = process.env.BASE_URL

</script>

<style scoped>
@media screen and (min-width: 520px) {
    .top-search-btn {
        padding-right: 150px;
        opacity: 0.8;
    }
}

@media screen and (max-width: 520px) {
    .top-search-btn {
        padding-right: 80px;
        opacity: 0.8;
    }
}
</style>